<template>
  <div class="container-fluid bg-dark row p-3">
    <div class="col">
      <h4 class="text-white" >
        خدمات 
      </h4>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
    </div>
    <div class="col">
      <h4 class="text-white" >
        پشتیبانی 
      </h4>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
    </div>
    <div class="col">
      <h4 class="text-white" >
        محصولات 
      </h4>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
    </div>
    <div class="col">
      <h4 class="text-white" >
        شبکه های اجتماعی 
      </h4>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
      <p> --------------- </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
